// Lehké kanály bez aplikace (CO-PODCHYTIT část 2, úkol 3.6): Telegram bot, později WhatsApp.
// Kanál je jen další vstup do interactions; párování účtu kódem z Nastavení, Buddy.
import { z } from 'zod'

export const CHANNEL_PROVIDERS = ['telegram'] as const
export const channelProviderSchema = z.enum(CHANNEL_PROVIDERS)
export type ChannelProvider = z.infer<typeof channelProviderSchema>

/** Párovací kód: 6 znaků bez nejednoznačných písmen, platí 15 minut. */
export const PAIRING_CODE_LENGTH = 6
export const PAIRING_CODE_TTL_MINUTES = 15
export const PAIRING_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
export const pairingCodeSchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(new RegExp(`^[${PAIRING_CODE_ALPHABET}]{${PAIRING_CODE_LENGTH}}$`), 'Neplatný kód')

/** GET /v1/me/channels/telegram */
export interface TelegramStatus {
  /** false = bot není nastavený na serveru (chybí TELEGRAM_BOT_TOKEN), UI ukáže vysvětlení. */
  available: boolean
  botUsername: string | null
  linked: boolean
  /** Jméno nebo uživatelské jméno v Telegramu po spárování. */
  displayName: string | null
  linkedAt: string | null
  /** Rozpracované párování (kód ještě nevypršel). */
  pairing: TelegramPairing | null
}

/** POST /v1/me/channels/telegram/pairing: nový kód a odkaz na bota. */
export interface TelegramPairing {
  code: string
  /** https://t.me/<bot>?start=<kód> */
  deepLink: string
  expiresAt: string
}
